export default (state = {}, action) => {
  let { type, payload } = action
  switch (type) {
    case 'FEATURE_FIELD_CREATE':
      return Object.assign(state, payload)
    case 'FEATURE_FIELD_CLEAR':
      return {}
    case 'LOGOUT':
      return {}
    default:
      return state
  }
}
